export default __webpack_public_path__ + "static/certificado-instalacion-1762c901060803149bce3d1093ce5cab.pdf";